
import { Vue, Component, Prop } from 'vue-property-decorator'

import CustomWrapper from '@/components/CustomWrapper.vue'

const config = {
  name: 'c-video-card-summary',
  components: { CustomWrapper }
}

@Component(config)
export default class CVideoCardSummary extends Vue {

  @Prop({ type: String, default: 'div' }) tag!: string

}
